import React, { useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { AgGridReact } from '@ag-grid-community/react';
import { defaultGridHeight } from './utils';
import { useIncreasedMonthlyPCardContext } from 'contexts/CategoryInsightsKpi/IncreasedMonthlyPCardProvider';

const IncreasedMonthlyPCardExplore = () => {
	const { gridData } = useIncreasedMonthlyPCardContext();
	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`P-card spend increase seen month over month.`}
				</AnalysisDescription>
				<TableContainer>
					<div style={gridStyle} className="ag-theme-balham">
						<AgGridReact {...gridData} />
					</div>
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default IncreasedMonthlyPCardExplore;
